// extracted by mini-css-extract-plugin
module.exports = {"container":"table-no-results_container__AhB_N","icon":"table-no-results_icon__3drFE","label":"table-no-results_label__k5z3y","fade-in":"table-no-results_fade-in__SfZjI"};